import axios from 'axios'
import { Auth } from 'aws-amplify'
import Vue from 'vue'
import { format } from 'date-fns'

export const loaders = {
  MEETINGS: 'meetings',
  BOOKIE_BETS: 'bookie_bets',
  BETS: 'bets',
  RACES: 'races',
  RUNNERS: 'runners'
}

const mapLoaders = Object.values(loaders).reduce((acc, curr) => {
  acc[curr] = false
  return acc
}, {})

const authHeaders = (u, t) => {
  return { Authorization: `Bearer ${t}` }
}

export default {
  state: {
    data: [],
    bets: [],
    runners: [],
    betsByCustomer: [],
    betsByType: [],
    betsByBookie: [],
    childBets: {},
    filteredBets: {},
    races: [],
    countryRaces: [],
    secondRaces: [],
    bookiesrace: [],
    bookiescolumn: [],
    allBookies: [],
    bookies: [],
    betbacks: [],
    exportSuccess: false,
    exportFailed: false,
    filteredBetBacks: [],
    exportFilters: {},
    listOfCodes: ['THOROUGHBRED', 'HARNESS', 'GREYHOUND'],
    page: 1,
    totalPages: 0,
    itemsPerPage: 0,
    isTokenExpired: false,
    sortByBetTime: false,
    darkModeST: 'light',
    allRaces: true,
    noRacesAvail: false,
    staleDateRange: { start: format(new Date(), 'yyyy-MM-dd'), end: format(new Date(), 'yyyy-MM-dd') },
    loading: {
      ...mapLoaders,
      load: (loader) => ({ loader, loading: true }),
      unload: (loader) => ({ loader, loading: false })
    },
    error: '',
    medium: '',
    infoType: '',
    betType: '',
    source: '',
    betId: '',
    clientRef: '',
    raceNumber: '',
    runnerNumber: '',
    time: '',
    country: '',
    meetingType: '',
    state: '',
    restartPagination: false,
    meetingId: '',
    runnersArray: '',
    betBack: '',
    sortFields: {},
    filtersApplied: {
      id: false,
      user_id: false,
      medium: false,
      info_type: false,
      time: false,
      race_number: false,
      runner_number: false,
      type: false,
      source: false
    },
    clearFiltersBy: false,
    tokenExpiry: 0,
    enrolledTerminals: [],
    betTickets: [],
    ticketSelected: {},
    terminalSelected: {}
  },
  getters: {
    getPagination (state) {
      return { page: state.page, totalPages: state.totalPages, itemsPerPage: state.itemsPerPage }
    },
    paginationForRequest (state) {
      return { page: state.page, limit: state.itemsPerPage }
    },
    getSelectedCodes (state) {
      return state.listOfCodes
    },
    hasFeature (state) {
      return function (feature) {
        const features = process.env.VUE_APP_FEATURE_FLAGS.split(',')
        return features.some((x) => x.trim() === feature.trim())
      }
    },
    getFilteredBets (state) {
      return state.filteredBets
    },
    getFiltersApplied (state) {
      return state.filtersApplied
    },
    getClearFiltersBy (state) {
      return state.clearFiltersBy
    },
    getEnrolledTerminals (state) {
      return state.enrolledTerminals
    },
    getBetTickets (state) {
      return state.betTickets
    },
    getTicketSelected (state) {
      return state.ticketSelected
    },
    getTerminalSelected (state) {
      return state.terminalSelected
    }
    /**
     * TODO: Deprecate once new api hooked up!
     * @param state
     * @returns {[]|*[]}
     */
  },
  mutations: {
    isTokenExpired (state, val) {
      state.isTokenExpired = val
    },
    setLoading (state, { loader, loading }) {
      state.loading[loader] = loading
    },
    setPage (state, page) {
      state.page = page
    },
    setTotalPages (state, totalPages) {
      state.totalPages = totalPages
    },
    setItemsPerPage (state, itemsPerPage) {
      state.itemsPerPage = itemsPerPage
    },
    setData (state, data) {
      // state.data = Object.keys(data);
      state.data = data
    },
    setRaces (state, races) {
      state.races = races
    },
    setCountryRaces (state, races) {
      state.countryRaces = races
    },
    setSecondRaces (state, races) {
      state.secondRaces = races
    },
    setRunners (state, runners) {
      state.runners = runners
    },
    clearRunners (state) {
      state.runners = []
    },
    clearExport (state) {
      state.exportSuccess = false
      state.exportFailed = false
    },
    setMeetings (state, meetings) {
      state.meetings = meetings
    },
    setBets (state, bets) {
      state.bets = bets
    },
    setBetBacks (state, betbacks) {
      state.betbacks = betbacks
    },
    setBookies (state, bookies) {
      state.bookies = bookies
    },
    setBookiesOnRace (state, bookiesrace) {
      state.bookiesrace = bookiesrace
    },
    setBookiesColumn (state, bookiescolumn) {
      state.bookiescolumn = bookiescolumn
    },
    setBetsByCustomer (state, betsByCustomer) {
      state.betsByCustomer = betsByCustomer
    },
    setBetsByType (state, betsByType) {
      state.betsByType = betsByType
    },
    setBetsByBookie (state, betsByBookie) {
      state.betsByBookie = betsByBookie
    },
    setAllBookies (state, allBookies) {
      state.allBookies = allBookies
    },
    clearFilteredBets (state) {
      state.filteredBets = {}
    },
    clearChildBets (state) {
      state.childBets = {}
    },
    setFilteredBets (state, { bets, pageNumber }) {
      Vue.set(state.filteredBets, pageNumber, bets)
      // state.filteredBets = bets
    },
    setFilteredBetBacks (state, betbacks) {
      state.filteredBetBacks = betbacks
    },
    setError (state, error = '') {
      state.error = error
    },
    setSortByBetTime (state, betTime) {
      state.sortByBetTime = betTime
    },
    updateCodes (state, value) {
      state.listOfCodes = value
    },
    setDarkMode (state, mode) {
      state.darkModeST = mode
    },
    updateAllRaces (state, value) {
      state.allRaces = value
    },
    updateNoRacesAvail (state, value) {
      state.noRacesAvail = value
    },
    setChildBets (state, bet) {
      if (!bet) {
        return
      }
      const key = `${bet[0].id}${bet[0].source}`
      Vue.set(state.childBets, key, bet)
    },
    setStaleDateRange (state, value) {
      state.staleDateRange = value
    },
    clearBetsByType (state) {
      state.betsByType = []
    },
    setSelectedMedium (state, value) {
      state.medium = value
    },
    setSelectedInfoType (state, value) {
      state.infoType = value
    },
    setSelectedBetType (state, value) {
      state.betType = value
    },
    setSelectedSource (state, value) {
      state.source = value
    },
    setSelectedBetId (state, value) {
      state.betId = value
    },
    setSelectedClientRef (state, value) {
      state.clientRef = value
    },
    setSelectedRaceNumber (state, value) {
      state.raceNumber = value
    },
    setSelectedRunnerNumber (state, value) {
      state.runnerNumber = value
    },
    setSelectedTime (state, value) {
      state.time = value
    },
    setSelectedCountry (state, value) {
      state.country = value
    },
    setSelectedMeetingType (state, value) {
      state.meetingType = value
    },
    setSelectedState (state, value) {
      state.state = value
    },
    clearMeetingType (state) {
      state.meetingType = null
    },
    setRestartPagination (state, value) {
      state.restartPagination = value
    },
    setSelectedMeetingId (state, value) {
      state.meetingId = value
    },
    setSelectedRunnersArray (state, value) {
      state.runnersArray = value
    },
    setSelectedBetBack (state, value) {
      state.betBack = value
    },
    setSortFields (state, fields) {
      state.sortFields = fields
    },
    setExportFilters (state, filters) {
      state.exportFilters = filters
    },
    clearExportFilters (state) {
      state.exportFilters = {}
    },
    setClearFiltersBy (state, value) {
      state.clearFiltersBy = value
    },
    resetFiltersApplied (state) {
      state.filtersApplied = {
        id: false,
        user_id: false,
        medium: false,
        info_type: false,
        time: false,
        race_number: false,
        runner_number: false,
        type: false,
        source: false
      }
    },
    setTokenExpiry (state, expiry) {
      state.tokenExpiry = expiry
    },
    setEnrolledTerminals (state, { terminals }) {
      state.enrolledTerminals = terminals
    },
    setTicketsForTerminal (state, { tickets }) {
      state.betTickets = tickets
    },
    setTicket (state, { ticket }) {
      state.ticketSelected = ticket
    },
    setTerminalSelected (state, { terminal }) {
      state.terminalSelected = terminal
    }
  },
  actions: {
    setTokenExpiry (context, expiry) {
      context.commit('setTokenExpiry', expiry)
    },
    setExportFilters (context, filters) {
      context.commit('setExportFilters', filters)
    },
    clearExportFilters (context) {
      context.commit('clearExportFilters')
    },
    setSelectedMeetingId (context, value) {
      context.commit('setSelectedMeetingId', value)
    },
    setSelectedRunnersArray (context, value) {
      context.commit('setSelectedRunnersArray', value)
    },
    setSelectedBetBack (context, value) {
      context.commit('setSelectedBetBack', value)
    },
    clearMeetingType (context) {
      context.commit('clearMeetingType')
    },
    clearBetsByType (context) {
      context.commit('clearBetsByType')
    },
    setDarkMode (context, mode) {
      context.commit('setDarkMode', mode)
    },
    setSortByBetTime (context, betTime) {
      context.commit('setSortByBetTime', betTime)
    },
    setError (context, error = '') {
      context.commit('setError', error)
    },
    updateRaceFilters (context, value) {
      context.commit('updateCodes', value)
    },
    updateAllRaces (context, value) {
      context.commit('updateAllRaces', value)
    },
    updateNoRacesAvail (context, value) {
      context.commit('updateNoRacesAvail', value)
    },
    clearRaces (context, value) {
      context.commit('setRaces', value)
    },
    setStaleDateRange (context, date) {
      context.commit('setStaleDateRange', date)
    },

    async fetchStateValues (context) {
      try {
        const { data } = await axios.post('/public/filters', { params: { countries: [context.state.countryOf] } })
        context.commit('setStateValues', data.states)
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchMeetings (context) {
      context.commit('setLoading', context.state.loading.load(loaders.MEETINGS))
      const params = {
        date_from: context.state.dateFrom,
        country: context.state.selectedCountry || '',
        state: context.state.selectedState || '',
        meeting_type: context.state.selectedCode || ''
      }
      if (context.state.dateTo !== context.state.dateFrom) {
        params.date_to = context.state.dateTo
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/meetings', params, { headers: auth })
        context.commit('setData', data.data.reduce((acc, curr) => {
          const index = acc.findIndex((meeting) => meeting?.track === curr.track &&
            meeting.meeting_type === curr.meeting_type)
          if (index > -1) {
            acc[index].meetings = [...acc[index].meetings, { ...curr }]
          } else {
            // eslint-disable-next-line no-param-reassign
            acc = [
              ...acc,
              { track: curr.track, meeting_type: curr.meetingType, meetings: [{ ...curr }] }]
              .sort((a, b) => a.track.localeCompare(b.track))
          }
          return acc
        }, []).sort((a, b) => b.meeting_type.localeCompare(a.meeting_type)))
        context.commit('setLoading', context.state.loading.unload(loaders.MEETINGS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchRaces (context) {
      context.commit('setLoading', context.state.loading.load(loaders.RACES))
      const {
        selectedMeeting: activeMeeting,
        selectedDate: activeDate,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      const params = {
        date_from: activeDate || context.state.dateFrom,
        // eslint-disable-next-line camelcase
        track: activeMeeting?.track || '',
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        source: activeBookie || '',
        country: activeCountry || '',
        state: activeState || '',
        meeting_type: activeCode || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/races', params, { headers: auth })
        const dataSorted = data.data.sort((a, b) => a.track.localeCompare(b.track))
        context.commit('setRaces', dataSorted.sort((a, b) => b.meeting_type.localeCompare(a.meeting_type)))
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
      } catch (error) {
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
        context.commit('setError', error.toString())
      }
    },

    async fetchCountryRaces (context) {
      const {
        selectedBookie: activeBookie
      } = context.state
      const params = {
        date_from: context.state.dateFrom || '',
        date_to: context.state.dateTo || '',
        source: activeBookie || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/meetings', params, { headers: auth })
        context.commit('setCountryRaces', data.data)
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchAllRaces (context) {
      context.commit('setLoading', context.state.loading.load(loaders.RACES))
      const {
        selectedMeeting: activeMeeting,
        selectedDate: activeDate,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      const params = {
        date_from: activeDate || context.state.dateFrom,
        date_to: context.state.dateTo || '',
        // eslint-disable-next-line camelcase
        track: activeMeeting?.track || '',
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        source: activeBookie || '',
        country: activeCountry || '',
        state: activeState || '',
        meeting_type: activeCode || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/races', params, { headers: auth })
        const dataSorted = data.data.sort((a, b) => a.track.localeCompare(b.track))
        context.commit('setRaces', dataSorted.sort((a, b) => b.meeting_type.localeCompare(a.meeting_type)))
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
      } catch (error) {
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
        context.commit('setError', error.toString())
      }
    },

    async fetchSecondMeetings (context) {
      context.commit('setLoading', context.state.loading.load(loaders.RACES))
      const {
        selectedMeeting: activeMeeting,
        selectedDate: activeDate,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      const params = {
        date_from: activeDate || context.state.dateFrom,
        date_to: context.state.dateTo || '',
        // eslint-disable-next-line camelcase
        track: activeMeeting?.track || '',
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        source: activeBookie || '',
        country: activeCountry || '',
        state: activeState || '',
        meeting_type: activeCode || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/races', params, { headers: auth })
        context.commit('setSecondRaces', data.data)
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
      } catch (error) {
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
        context.commit('setError', error.toString())
      }
    },

    async fetchRacesDated (context) {
      context.commit('setLoading', context.state.loading.load(loaders.RACES))
      const {
        selectedMeeting: activeMeeting,
        selectedDate: activeDate,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      const params = {
        date_from: activeDate || context.state.dateFrom,
        date_to: context.state.dateTo || '',
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        source: activeBookie || '',
        country: activeCountry || '',
        state: activeState || '',
        meeting_type: activeCode || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/races', params, { headers: auth })
        const dataSorted = data.data.sort((a, b) => a.track.localeCompare(b.track))
        context.commit('setRaces', dataSorted.sort((a, b) => b.meetingType.localeCompare(a.meetingType)))
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
      } catch (error) {
        context.commit('setLoading', context.state.loading.unload(loaders.RACES))
        context.commit('setSelectedMeeting', null)
        // context.commit('updateAllRaces', true)
        context.commit('updateNoRacesAvail', true)
        context.commit('setError', error.toString())
      }
    },

    /**
     * @param commit
     * @param state
     * @param getters
     * @param overrides - ability to override global params
     * @param filtered - should data be stored in bets or filtered bets
     * @returns {Promise<void>}
     */

    async fetchRunners (context) {
      context.commit('setLoading', context.state.loading.load(loaders.RUNNERS))
      const {
        selectedMeeting: activeMeeting,
        selectedRace: activeRace,
        selectedBookie: activeBookie
      } = context.state
      const params = {
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber || 0,
        source: activeBookie || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/runners', params, { headers: auth })
        context.commit('setRunners', data.data)
        context.commit('setLoading', context.state.loading.unload(loaders.RUNNERS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBetsByCustomer (context) {
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRace: activeRace
      } = context.state
      const params = {
        bets_from: `${dateFrom} 00:00:00`,
        bets_to: `${dateTo} 23:59:59`,
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber || 0
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/betsByCustomer', params, { headers: auth })
        context.commit('setBetsByCustomer', data?.data || [])
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchChildBets (context, bet) {
      const params = {
        source: bet.source,
        id: bet.id,
        time: bet.time,
        limit: 100,
        page: 1
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('/public/bets', params, { headers: auth })
        context.commit('setChildBets', data.data.sort((a, b) => parseInt(a.leg) - (parseInt(b.leg))))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBets (context, overrides = {}) {
      context.commit('setLoading', context.state.loading.load(loaders.BETS))
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRunner: activeRunner,
        selectedRace: activeRace,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      let params = {}
      if (context.state.sortByBetTime === false) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          race_number: activeRace?.raceNumber || 0,
          runner_number: activeRunner?.tabNo || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          meeting_type: activeCode || '',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      if (context.state.sortByBetTime === true) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          race_number: activeRace?.raceNumber || 0,
          runner_number: activeRunner?.tabNo || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          sort_by: 'bet_time',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
        if (overrides.filtered) {
          context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
        } else {
          context.commit('setBets', data?.data || [])
        }

        // eslint-disable-next-line camelcase
        context.commit('setTotalPages', data.total_records || 0)
        context.commit('setLoading', context.state.loading.unload(loaders.BETS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },
    setRestartPagination (context, value) {
      context.commit('setRestartPagination', value)
    },
    clearFiltersBy (context, value) {
      context.commit('setClearFiltersBy', value)
    },
    clearFiltersApplied (context) {
      context.commit('resetFiltersApplied')
    },
    async fetchBetSummary (context, { medium, infoType, betType, source, betId, clientRef, raceNumber, runnerNumber, time, country, meetingType, state, clearFilteredBets, runnersArray, betBack, sortFields = {}, overrides = {} }) {
      if (Object.keys(context.state.filteredBets).length === 0) {
        context.commit('setLoading', context.state.loading.load(loaders.BETS))
      }

      if (clearFilteredBets) {
        context.commit('clearFilteredBets')
      }

      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRunner: activeRunner,
        selectedRace: activeRace,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      let params = {}
      if (context.state.sortByBetTime === false) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          race_number: activeRace?.raceNumber || 0,
          runner_number: activeRunner?.tabNo || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          meeting_type: activeCode || '',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      if (context.state.sortByBetTime === true) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          race_number: activeRace?.raceNumber || 0,
          runner_number: activeRunner?.tabNo || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          sort_by: 'bet_time',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      if (sortFields !== {} && sortFields?.sortBy !== 'intoState') {
        params.sort_by = sortFields?.sortBy
        params.sort_type = sortFields?.sortType
        context.commit('setSortFields', sortFields)
      } else if (sortFields?.sortBy === 'intoState') {
        const selectedSortFields = context.state.sortFields
        if (selectedSortFields === {}) {
          delete params.sort_by
          delete params.sort_type
          context.commit('setSortFields', {})
        } else {
          params.sort_by = selectedSortFields?.sortBy
          params.sort_type = selectedSortFields?.sortType
        }
      } else {
        delete params.sort_by
        delete params.sort_type
        context.commit('setSortFields', {})
      }

      if (medium !== 'none' && medium !== 'intoState') {
        params.medium = medium
        context.commit('setSelectedMedium', medium)
        context.state.filtersApplied.medium = true
      } else if (medium === 'intoState') {
        const selectedMedium = context.state.medium
        if (selectedMedium === '') {
          delete params.medium
          context.commit('setSelectedMedium', '')
          context.state.filtersApplied.medium = false
        } else {
          params.medium = selectedMedium
          context.state.filtersApplied.medium = true
        }
      } else {
        delete params.medium
        context.commit('setSelectedMedium', '')
        context.state.filtersApplied.medium = false
      }
      if (infoType !== 'none' && infoType !== 'intoState') {
        params.info_type = infoType
        context.commit('setSelectedInfoType', infoType)
        context.state.filtersApplied.info_type = true
      } else if (infoType === 'intoState') {
        const selectedInfoType = context.state.infoType
        if (selectedInfoType === '') {
          delete params.info_type
          context.commit('setSelectedInfoType', '')
          context.state.filtersApplied.info_type = false
        } else {
          params.info_type = selectedInfoType
          context.state.filtersApplied.info_type = true
        }
      } else {
        delete params.info_type
        context.commit('setSelectedInfoType', '')
        context.state.filtersApplied.info_type = false
      }
      if (betType !== 'none' && betType !== 'intoState') {
        params.bet_type = betType
        context.commit('setSelectedBetType', betType)
        context.state.filtersApplied.type = true
      } else if (betType === 'intoState') {
        const selectedBetType = context.state.betType
        if (selectedBetType === '') {
          delete params.bet_type
          context.commit('setSelectedBetType', '')
          context.state.filtersApplied.type = false
        } else {
          params.bet_type = selectedBetType
          context.state.filtersApplied.type = true
        }
      } else {
        delete params.bet_type
        context.commit('setSelectedBetType', '')
        context.state.filtersApplied.type = false
      }

      if (activeBookie === null) {
        if (source !== 'none' && source !== 'intoState') {
          params.source = source
          context.commit('setSelectedSource', source)
          context.state.filtersApplied.source = true
        } else if (source === 'intoState') {
          const selectedSource = context.state.source
          if (selectedSource === '') {
            delete params.source
            context.commit('setSelectedSource', '')
            context.state.filtersApplied.source = false
          } else {
            params.source = selectedSource
            context.state.filtersApplied.source = true
          }
        } else {
          delete params.source
          context.commit('setSelectedSource', '')
          context.state.filtersApplied.source = false
        }
      }

      if (betId !== '' && betId !== 'intoState') {
        params.id = betId
        context.commit('setSelectedBetId', betId)
        context.state.filtersApplied.id = true
      } else if (betId === 'intoState') {
        const selectedBetId = context.state.betId
        if (selectedBetId === '') {
          delete params.id
          context.commit('setSelectedBetId', '')
          context.state.filtersApplied.id = false
        } else {
          params.id = selectedBetId
          context.state.filtersApplied.id = true
        }
      } else {
        delete params.id
        context.commit('setSelectedBetId', '')
        context.state.filtersApplied.id = false
      }
      if (clientRef !== '' && clientRef !== 'intoState') {
        params.user_id = clientRef
        context.commit('setSelectedClientRef', clientRef)
        context.state.filtersApplied.user_id = true
      } else if (clientRef === 'intoState') {
        const selectedClientRef = context.state.clientRef
        if (selectedClientRef === '') {
          delete params.user_id
          context.commit('setSelectedClientRef', '')
          context.state.filtersApplied.user_id = false
        } else {
          params.user_id = selectedClientRef
          context.state.filtersApplied.user_id = true
        }
      } else {
        delete params.user_id
        context.commit('setSelectedClientRef', '')
        context.state.filtersApplied.user_id = false
      }
      if (activeRace === null) {
        if (raceNumber !== '' && raceNumber !== 'intoState') {
          params.race_number = raceNumber
          context.commit('setSelectedRaceNumber', raceNumber)
          context.state.filtersApplied.race_number = true
        } else if (raceNumber === 'intoState') {
          const selectedRaceNumber = context.state.raceNumber
          if (selectedRaceNumber === '') {
            delete params.race_number
            context.commit('setSelectedRaceNumber', '')
            context.state.filtersApplied.race_number = false
          } else {
            params.race_number = selectedRaceNumber
            context.state.filtersApplied.race_number = true
          }
        } else {
          delete params.race_number
          context.commit('setSelectedRaceNumber', '')
          context.state.filtersApplied.race_number = false
        }
      }
      if (activeRunner === null) {
        if (runnerNumber !== '' && runnerNumber !== 'intoState') {
          params.runner_number = runnerNumber
          context.commit('setSelectedRunnerNumber', runnerNumber)
          context.state.filtersApplied.runner_number = true
        } else if (runnerNumber === 'intoState') {
          const selectedRunnerNumber = context.state.runnerNumber
          if (selectedRunnerNumber === '') {
            delete params.runner_number
            context.commit('setSelectedRunnerNumber', '')
            context.state.filtersApplied.runner_number = false
          } else {
            params.runner_number = selectedRunnerNumber
            context.state.filtersApplied.runner_number = true
          }
        } else {
          delete params.runner_number
          context.commit('setSelectedRunnerNumber', '')
          context.state.filtersApplied.runner_number = false
        }
      }
      if (time !== '' && time !== 'intoState') {
        params.time = time
        context.commit('setSelectedTime', time)
        context.state.filtersApplied.time = true
      } else if (time === 'intoState') {
        const selectedTime = context.state.time
        if (selectedTime === '') {
          delete params.time
          context.commit('setSelectedTime', '')
          context.state.filtersApplied.time = false
        } else {
          params.time = selectedTime
          context.state.filtersApplied.time = true
        }
      } else {
        delete params.time
        context.commit('setSelectedTime', '')
        context.state.filtersApplied.time = false
      }
      if (activeCountry === '' || activeCountry === null || activeCountry !== country) {
        if (country !== 'none' && country !== 'intoState') {
          params.country = country
          context.commit('setSelectedCountry', country)
        } else if (country === 'intoState') {
          const selectedCountry = context.state.country
          if (params.country === '') {
            if (selectedCountry === '') {
              delete params.country
              context.commit('setSelectedCountry', '')
            } else {
              params.country = selectedCountry
            }
          }
        } else if (!activeCountry) {
          delete params.country
          context.commit('setSelectedCountry', '')
        }
      }
      if (activeCode === '' || activeCode === null || activeCode !== meetingType) {
        if (meetingType !== 'none' && meetingType !== 'intoState') {
          params.meeting_type = meetingType
          context.commit('setSelectedMeetingType', meetingType)
        } else if (meetingType === 'intoState') {
          const selectedMeetingType = context.state.meetingType
          if (params.meeting_type === '') {
            if (selectedMeetingType === '') {
              delete params.meeting_type
              context.commit('setSelectedMeetingType', '')
            } else {
              params.meeting_type = selectedMeetingType
            }
          }
        } else if (!activeCode) {
          delete params.meeting_type
          context.commit('setSelectedMeetingType', '')
        }
      }
      if (activeState === '' || activeState === null || activeState !== state) {
        if (state !== 'none' && state !== 'intoState') {
          params.state = state
          context.commit('setSelectedState', state)
        } else if (state === 'intoState') {
          const selectedState = context.state.state
          if (params.state === '') {
            if (selectedState === '') {
              delete params.state
              context.commit('setSelectedState', '')
            } else {
              params.state = selectedState
            }
          }
        } else if (!activeState) {
          delete params.state
          context.commit('setSelectedState', '')
        }
      }

      // if (meetingId !== '' && meetingId !== 'intoState') {
      //   params.meeting_id = meetingId
      //   context.commit('setSelectedMeetingId', meetingId)
      // } else if (meetingId === 'intoState') {
      //   const selectedMeetingId = context.state.meetingId
      //   if (selectedMeetingId === '') {
      //     delete params.meeting_id
      //     context.commit('setSelectedMeetingId', '')
      //   } else {
      //     params.meeting_id = selectedMeetingId
      //   }
      // } else {
      //   delete params.meeting_id
      //   context.commit('setSelectedMeetingId', '')
      // }

      if (runnersArray !== '' && runnersArray !== 'intoState') {
        params.runners = runnersArray
        context.commit('setSelectedRunnersArray', runnersArray)
      } else if (runnersArray === 'intoState') {
        const selectedRunnersArray = context.state.runnersArray
        if (selectedRunnersArray === '') {
          delete params.runners
          context.commit('setSelectedRunnersArray', '')
        } else {
          params.runners = selectedRunnersArray
        }
      } else {
        delete params.runners
        context.commit('setSelectedRunnersArray', '')
      }

      if (betBack !== 'none' && betBack !== 'intoState') {
        params.bet_back = betBack
        context.commit('setSelectedBetBack', betBack)
      } else if (betBack === 'intoState') {
        const selectedBetBack = context.state.betBack
        if (params.bet_back === '') {
          if (selectedBetBack === '') {
            delete params.bet_back
            context.commit('setSelectedBetBack', '')
          } else {
            params.bet_back = selectedBetBack
          }
        }
      } else {
        delete params.bet_back
        context.commit('setSelectedBetBack', '')
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        if (params.page <= 2) {
          for (let index = params.page; index < 4; index++) {
            params.page = index
            if (!context.state.filteredBets[params.page]) {
              const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
              if (overrides.filtered) {
                context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
              } else {
                context.commit('setBets', data?.data || [])
              }
              context.commit('setLoading', context.state.loading.unload(loaders.BETS))
              if (data?.data.length < 100) {
                break
              }
            }
          }
          params.page = context.state.page
        } else {
          const currentPage = params.page
          Object.keys(context.state.filteredBets).forEach(key => {
            if (currentPage - 2 !== parseInt(key) && currentPage - 1 !== parseInt(key) && currentPage !== parseInt(key) && currentPage + 1 !== parseInt(key) && currentPage + 2 !== parseInt(key)) {
              Vue.delete(context.state.filteredBets, key)
            }
          })

          if (!context.state.filteredBets[currentPage - 2]) {
            params.page = currentPage - 2
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage - 1]) {
            params.page = currentPage - 1
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage + 1]) {
            params.page = currentPage + 1
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage + 2]) {
            params.page = currentPage + 2
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }
        }

        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBetsRace (context, { overrides = {}, sortFields = {} }) {
      if (Object.keys(context.state.filteredBets).length === 0) {
        context.commit('setLoading', context.state.loading.load(loaders.BETS))
      }
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRace: activeRace,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      let params = {}
      if (context.state.sortByBetTime === false) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          race_number: activeRace?.raceNumber || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          meeting_type: activeCode || '',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      if (context.state.sortByBetTime === true) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          race_number: activeRace?.raceNumber || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          sort_by: 'bet_time',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }

      if (sortFields !== {}) {
        params.sort_by = sortFields?.sortBy
        params.sort_type = sortFields?.sortType
        context.commit('setSortFields', {})
      } else {
        const selectedSortFields = context.state.sortFields
        if (selectedSortFields !== {}) {
          params.sort_by = selectedSortFields?.sortBy
          params.sort_type = selectedSortFields?.sortType
        }
      }

      const auth = authHeaders(context.state.user.username, context.state.user.token)

      // try {
      //   const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
      //   if (overrides.filtered) {
      //     context.commit('setFilteredBets', data?.data || [])
      //   } else {
      //     context.commit('setBets', data?.data || [])
      //   }
      //   // eslint-disable-next-line camelcase
      //   context.commit('setTotalPages', data.total_records || 0)
      //   context.commit('setLoading', context.state.loading.unload(loaders.BETS))
      // } catch (error) {
      //   context.commit('setError', error.toString())
      // }

      try {
        if (params.page <= 2) {
          for (let index = params.page; index < 4; index++) {
            params.page = index
            if (!context.state.filteredBets[params.page]) {
              const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
              if (overrides.filtered) {
                context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
              } else {
                context.commit('setBets', data?.data || [])
              }
              context.commit('setLoading', context.state.loading.unload(loaders.BETS))
            }
          }
          params.page = context.state.page
        } else {
          const currentPage = params.page
          Object.keys(context.state.filteredBets).forEach(key => {
            if (currentPage - 2 !== parseInt(key) && currentPage - 1 !== parseInt(key) && currentPage !== parseInt(key) && currentPage + 1 !== parseInt(key) && currentPage + 2 !== parseInt(key)) {
              Vue.delete(context.state.filteredBets, key)
            }
          })

          if (!context.state.filteredBets[currentPage - 2]) {
            params.page = currentPage - 2
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage - 1]) {
            params.page = currentPage - 1
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage + 1]) {
            params.page = currentPage + 1
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage + 2]) {
            params.page = currentPage + 2
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }
        }

        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBetsMeeting (context, { overrides = {}, sortFields = {} }) {
      if (Object.keys(context.state.filteredBets).length === 0) {
        context.commit('setLoading', context.state.loading.load(loaders.BETS))
      }
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      let params = {}
      if (context.state.sortByBetTime === false) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          meeting_type: activeCode || '',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      if (context.state.sortByBetTime === true) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          meeting_id: activeMeeting?.meetingId || 0,
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          sort_by: 'bet_time',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }

      if (sortFields !== {}) {
        params.sort_by = sortFields?.sortBy
        params.sort_type = sortFields?.sortType
        context.commit('setSortFields', {})
      } else {
        const selectedSortFields = context.state.sortFields
        if (selectedSortFields !== {}) {
          params.sort_by = selectedSortFields?.sortBy
          params.sort_type = selectedSortFields?.sortType
        }
      }

      const auth = authHeaders(context.state.user.username, context.state.user.token)

      // try {
      //   const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
      //   if (overrides.filtered) {
      //     context.commit('setFilteredBets', data?.data || [])
      //   } else {
      //     context.commit('setBets', data?.data || [])
      //   }
      //   // eslint-disable-next-line camelcase
      //   context.commit('setTotalPages', data.total_records || 0)
      //   context.commit('setLoading', context.state.loading.unload(loaders.BETS))
      // } catch (error) {
      //   context.commit('setError', error.toString())
      // }

      try {
        if (params.page <= 2) {
          for (let index = params.page; index < 4; index++) {
            params.page = index
            if (!context.state.filteredBets[params.page]) {
              const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
              if (overrides.filtered) {
                context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
              } else {
                context.commit('setBets', data?.data || [])
              }
              context.commit('setLoading', context.state.loading.unload(loaders.BETS))
            }
          }
          params.page = context.state.page
        } else {
          const currentPage = params.page
          Object.keys(context.state.filteredBets).forEach(key => {
            if (currentPage - 2 !== parseInt(key) && currentPage - 1 !== parseInt(key) && currentPage !== parseInt(key) && currentPage + 1 !== parseInt(key) && currentPage + 2 !== parseInt(key)) {
              Vue.delete(context.state.filteredBets, key)
            }
          })

          if (!context.state.filteredBets[currentPage - 2]) {
            params.page = currentPage - 2
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage - 1]) {
            params.page = currentPage - 1
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage + 1]) {
            params.page = currentPage + 1
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }

          if (!context.state.filteredBets[currentPage + 2]) {
            params.page = currentPage + 2
            const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
            if (overrides.filtered) {
              context.commit('setFilteredBets', { bets: data?.data || [], pageNumber: params.page })
            } else {
              context.commit('setBets', data?.data || [])
            }
          }
        }

        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBetsAll (context, overrides = {}) {
      context.commit('setLoading', context.state.loading.load(loaders.BETS))
      const {
        dateFrom,
        dateTo,
        selectedBookie: activeBookie,
        selectedState: activeState,
        selectedCountry: activeCountry,
        selectedCode: activeCode
      } = context.state
      let params = {}
      if (context.state.sortByBetTime === false) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          meeting_type: activeCode || '',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      if (context.state.sortByBetTime === true) {
        params = {
          date_from: `${dateFrom} 00:00:00`,
          date_to: `${dateTo} 23:59:59`,
          /* eslint-disable camelcase */
          source: activeBookie || '',
          country: activeCountry || '',
          state: activeState || '',
          sort_by: 'bet_time',
          /* eslint-enable camelcase */
          ...context.getters.paginationForRequest,
          ...overrides?.pagination || {}
        }
      }
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsSummary', params, { headers: auth })
        if (overrides.filtered) {
          context.commit('setFilteredBets', data?.data || [])
        } else {
          context.commit('setBets', data?.data || [])
        }
        // eslint-disable-next-line camelcase
        context.commit('setTotalPages', data.total_records || 0)
        context.commit('setLoading', context.state.loading.unload(loaders.BETS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async exportBets (context, { medium, infoType, betType, source, betId, clientRef, raceNumber, runnerNumber, time, country, meetingType, state, runnersArray, betBack, overrides = {} }) {
      const {
        dateFrom,
        dateTo,
        selectedBookie: activeBookie,
        selectedMeeting: activeMeeting,
        selectedRace: activeRace,
        selectedRunner: activeRunner,
        selectedFormat: activeFormat,
        selectedCountry: activeCountry,
        selectedState: activeState,
        selectedCode: activeCode
      } = context.state
      const format = activeFormat || ''
      const layout = 'Bets'
      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        source: activeBookie || '',
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber || 0,
        // eslint-disable-next-line camelcase
        runner_number: activeRunner?.tabNo || 0,
        country: activeCountry || '',
        state: activeState || '',
        meeting_type: activeCode || ''
      }
      if (medium !== 'none' && medium !== 'intoState') {
        params.medium = medium
        context.commit('setSelectedMedium', medium)
      } else if (medium === 'intoState') {
        const selectedMedium = context.state.medium
        if (selectedMedium === '') {
          delete params.medium
          context.commit('setSelectedMedium', '')
        } else {
          params.medium = selectedMedium
        }
      } else {
        delete params.medium
        context.commit('setSelectedMedium', '')
      }
      if (infoType !== 'none' && infoType !== 'intoState') {
        params.info_type = infoType
        context.commit('setSelectedInfoType', infoType)
      } else if (infoType === 'intoState') {
        const selectedInfoType = context.state.infoType
        if (selectedInfoType === '') {
          delete params.info_type
          context.commit('setSelectedInfoType', '')
        } else {
          params.info_type = selectedInfoType
        }
      } else {
        delete params.info_type
        context.commit('setSelectedInfoType', '')
      }
      if (betType !== 'none' && betType !== 'intoState') {
        params.bet_type = betType
        context.commit('setSelectedBetType', betType)
      } else if (betType === 'intoState') {
        const selectedBetType = context.state.betType
        if (selectedBetType === '') {
          delete params.bet_type
          context.commit('setSelectedBetType', '')
        } else {
          params.bet_type = selectedBetType
        }
      } else {
        delete params.bet_type
        context.commit('setSelectedBetType', '')
      }

      if (activeBookie === null) {
        if (source !== 'none' && source !== 'intoState') {
          params.source = source
          context.commit('setSelectedSource', source)
        } else if (source === 'intoState') {
          const selectedSource = context.state.source
          if (selectedSource === '') {
            delete params.source
            context.commit('setSelectedSource', '')
          } else {
            params.source = selectedSource
          }
        } else {
          delete params.source
          context.commit('setSelectedSource', '')
        }
      }

      if (betId !== '' && betId !== 'intoState') {
        params.id = betId
        context.commit('setSelectedBetId', betId)
      } else if (betId === 'intoState') {
        const selectedBetId = context.state.betId
        if (selectedBetId === '') {
          delete params.id
          context.commit('setSelectedBetId', '')
        } else {
          params.id = selectedBetId
        }
      } else {
        delete params.id
        context.commit('setSelectedBetId', '')
      }
      if (clientRef !== '' && clientRef !== 'intoState') {
        params.user_id = clientRef
        context.commit('setSelectedClientRef', clientRef)
      } else if (clientRef === 'intoState') {
        const selectedClientRef = context.state.clientRef
        if (selectedClientRef === '') {
          delete params.user_id
          context.commit('setSelectedClientRef', '')
        } else {
          params.user_id = selectedClientRef
        }
      } else {
        delete params.user_id
        context.commit('setSelectedClientRef', '')
      }
      if (activeRace === null) {
        if (raceNumber !== '' && raceNumber !== 'intoState') {
          params.race_number = raceNumber
          context.commit('setSelectedRaceNumber', raceNumber)
        } else if (raceNumber === 'intoState') {
          const selectedRaceNumber = context.state.raceNumber
          if (selectedRaceNumber === '') {
            delete params.race_number
            context.commit('setSelectedRaceNumber', '')
          } else {
            params.race_number = selectedRaceNumber
          }
        } else {
          delete params.race_number
          context.commit('setSelectedRaceNumber', '')
        }
      }
      if (runnerNumber !== '' && runnerNumber !== 'intoState') {
        params.runner_number = runnerNumber
        context.commit('setSelectedRunnerNumber', runnerNumber)
      } else if (runnerNumber === 'intoState') {
        const selectedRunnerNumber = context.state.runnerNumber
        if (selectedRunnerNumber === '') {
          delete params.runner_number
          context.commit('setSelectedRunnerNumber', '')
        } else {
          params.runner_number = selectedRunnerNumber
        }
      } else {
        delete params.runner_number
        context.commit('setSelectedRunnerNumber', '')
      }
      if (time !== '' && time !== 'intoState') {
        params.time = time
        context.commit('setSelectedTime', time)
      } else if (time === 'intoState') {
        const selectedTime = context.state.time
        if (selectedTime === '') {
          delete params.time
          context.commit('setSelectedTime', '')
        } else {
          params.time = selectedTime
        }
      } else {
        delete params.time
        context.commit('setSelectedTime', '')
      }
      if (activeCountry === '' || activeCountry === null) {
        if (country !== 'none' && country !== 'intoState') {
          params.country = country
          context.commit('setSelectedCountry', country)
        } else if (country === 'intoState') {
          const selectedCountry = context.state.country
          if (params.country === '') {
            if (selectedCountry === '') {
              delete params.country
              context.commit('setSelectedCountry', '')
            } else {
              params.country = selectedCountry
            }
          }
        } else if (!activeCountry) {
          delete params.country
          context.commit('setSelectedCountry', '')
        }
      }
      if (activeCode === '' || activeCode === null) {
        if (meetingType !== 'none' && meetingType !== 'intoState') {
          params.meeting_type = meetingType
          context.commit('setSelectedMeetingType', meetingType)
        } else if (meetingType === 'intoState') {
          const selectedMeetingType = context.state.meetingType
          if (params.meeting_type === '') {
            if (selectedMeetingType === '') {
              delete params.meeting_type
              context.commit('setSelectedMeetingType', '')
            } else {
              params.meeting_type = selectedMeetingType
            }
          }
        } else if (!activeCode) {
          delete params.meeting_type
          context.commit('setSelectedMeetingType', '')
        }
      }
      if (activeState === '' || activeState === null) {
        if (state !== 'none' && state !== 'intoState') {
          params.state = state
          context.commit('setSelectedState', state)
        } else if (state === 'intoState') {
          const selectedState = context.state.state
          if (params.state === '') {
            if (selectedState === '') {
              delete params.state
              context.commit('setSelectedState', '')
            } else {
              params.state = selectedState
            }
          }
        } else if (!activeState) {
          delete params.state
          context.commit('setSelectedState', '')
        }
      }
      if (runnersArray !== '' && runnersArray !== 'intoState') {
        params.runners = runnersArray
        context.commit('setSelectedRunnersArray', runnersArray)
      } else if (runnersArray === 'intoState') {
        const selectedRunnersArray = context.state.runnersArray
        if (selectedRunnersArray === '') {
          delete params.runners
          context.commit('setSelectedRunnersArray', '')
        } else {
          params.runners = selectedRunnersArray
        }
      } else {
        delete params.runners
        context.commit('setSelectedRunnersArray', '')
      }

      if (betBack !== 'none' && betBack !== 'intoState') {
        params.bet_back = betBack
        context.commit('setSelectedBetBack', betBack)
      } else if (betBack === 'intoState') {
        const selectedBetBack = context.state.betBack
        if (params.bet_back === '') {
          if (selectedBetBack === '') {
            delete params.bet_back
            context.commit('setSelectedBetBack', '')
          } else {
            params.bet_back = selectedBetBack
          }
        }
      } else {
        delete params.bet_back
        context.commit('setSelectedBetBack', '')
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        await axios.post('/public/exportBets', {
          format, layout, params
        },
        { headers: auth }).then((response) => {
          if (response.data.message === 'export started') {
            // eslint-disable-next-line no-param-reassign
            context.state.exportSuccess = true
          } else {
            // eslint-disable-next-line no-param-reassign
            context.state.exportFailed = true
          }
        })
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },
    clearFilteredBets (context) {
      context.commit('clearFilteredBets')
    },
    clearChildBets (context) {
      context.commit('clearChildBets')
    },
    async fetchBetBacks (context, overrides = {}) {
      context.commit('setLoading', context.state.loading.load(loaders.BETS))
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRunner: activeRunner,
        selectedRace: activeRace,
        selectedBookie: activeBookie
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        /* eslint-disable camelcase */
        meeting_id: activeMeeting?.meetingId || 0,
        race_number: activeRace?.raceNumber || 0,
        runner_number: activeRunner?.tabNo || 0,
        source: activeBookie || '',
        bet_back: true,
        /* eslint-enable camelcase */
        ...context.getters.paginationForRequest,
        ...overrides?.pagination || {}
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/bets', params, { headers: auth })
        if (overrides.filtered) {
          context.commit('setFilteredBetBacks', data?.data || [])
        } else {
          context.commit('setBetBacks', data?.data || [])
        }

        // eslint-disable-next-line camelcase
        context.commit('setTotalPages', data.total_records || 0)
        context.commit('setLoading', context.state.loading.unload(loaders.BETS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBookieBets (context) {
      context.commit('setLoading', context.state.loading.load(loaders.BOOKIE_BETS))
      const {
        dateFrom,
        dateTo,
        selectedBookie: activeBookie
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        source: activeBookie || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookie', params, { headers: auth })
        context.commit('setBets', data?.data || [])
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchAllBookies (context) {
      // context.commit('clearFilteredBets')
      context.commit('setLoading', context.state.loading.load(loaders.BOOKIE_BETS))
      const {
        dateFrom,
        dateTo
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookie', params, { headers: auth })
        context.commit('setAllBookies', data?.data || [])
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBookies (context) {
      context.commit('setLoading', context.state.loading.load(loaders.BOOKIE_BETS))
      const {
        dateFrom,
        dateTo
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookie', params, { headers: auth })
        context.commit('setBookies', data?.data || [])
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBookieRace (context) {
      context.commit('setLoading', context.state.loading.load(loaders.BOOKIE_BETS))
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRace: activeRace,
        selectedCountry: activeCountry,
        selectedState: activeState,
        selectedCode: activeCode
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber || 0,
        country: activeCountry,
        state: activeState,
        meeting_type: activeCode || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookie', params, { headers: auth })
        context.commit('setBookiesOnRace', data?.data || [])
        context.commit('setBookiesColumn', data?.data || [])
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBookieMeeting (context) {
      context.commit('setLoading', context.state.loading.load(loaders.BOOKIE_BETS))
      const {
        dateFrom,
        dateTo,
        selectedMeeting: activeMeeting,
        selectedRace: activeRace,
        selectedCountry: activeCountry,
        selectedState: activeState,
        selectedCode: activeCode,
        selectedBookie: activeBookie
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber || 0,
        country: activeCountry,
        state: activeState,
        meeting_type: activeCode || '',
        source: activeBookie || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookie', params, { headers: auth })
        context.commit('setBookiesOnRace', data?.data || [])
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
        // eslint-disable-next-line camelcase
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBookieBetsDated (context) {
      const {
        dateFrom,
        dateTo,
        selectedBookie: activeBookie,
        selectedRace: activeRace,
        selectedMeeting: activeMeeting
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        source: activeBookie || '',
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber,
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookieDated', params, { headers: auth })
        context.commit('setBetsByBookie', data?.data || [])
        // eslint-disable-next-line camelcase
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBookieBetsCountry (context) {
      const {
        dateFrom,
        dateTo,
        selectedBookie: activeBookie,
        selectedRace: activeRace,
        selectedMeeting: activeMeeting,
        selectedCountry: activeCountry,
        selectedState: activeState,
        selectedCode: activeCode
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        source: activeBookie || '',
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber,
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId,
        country: activeCountry,
        state: activeState,
        meeting_type: activeCode || ''
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/betsByBookie', params, { headers: auth })
        context.commit('setAllBookies', data?.data || [])
        // eslint-disable-next-line camelcase
        context.commit('setLoading', context.state.loading.unload(loaders.BOOKIE_BETS))
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    async fetchBetsByType (context) {
      const {
        dateFrom,
        dateTo,
        selectedBookie: activeBookie,
        selectedRace: activeRace,
        selectedMeeting: activeMeeting
      } = context.state

      const params = {
        date_from: `${dateFrom} 00:00:00`,
        date_to: `${dateTo} 23:59:59`,
        source: activeBookie || '',
        // eslint-disable-next-line camelcase
        meeting_id: activeMeeting?.meetingId || 0,
        // eslint-disable-next-line camelcase
        race_number: activeRace?.raceNumber || 0
      }
      Auth.currentSession().then((res) => {
        context.dispatch('login', {
          token: res.getAccessToken().getJwtToken(),
          username: res.getAccessToken().decodePayload().username
        })
      })
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      try {
        const { data } = await axios.post('public/betsByType', params, { headers: auth })
        context.commit('setBetsByType', data.data)
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },

    setPage (context, page) {
      context.commit('setPage', page)
      context.dispatch('fetchData')
    },

    setItemsPerPage (context, itemsPerPage) {
      context.commit('setItemsPerPage', itemsPerPage)
      context.dispatch('fetchData')
    },

    async fetchEnrolledTerminals (context) {
      const auth = authHeaders(context.state.user.username, context.state.user.token)

      try {
        const { data } = await axios.post('/public/getEnrolledTerminals', {}, { headers: auth })
        const terminals = data.statuses.filter((terminal) => terminal.venueCode === 'MN')
        context.commit('setEnrolledTerminals', { terminals: terminals })
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },
    async fetchListTickets (context, { terminalId, dateFrom, dateTo }) {
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      const params = {
        terminal_id: terminalId,
        date_from: `${dateFrom}T00:00:00.000Z`,
        date_to: `${dateTo}T23:59:59.999Z`
      }
      try {
        const { data } = await axios.post('/public/getListTickets', params, { headers: auth })
        context.commit('setTicketsForTerminal', { tickets: data.bets })
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },
    async fetchTicket (context, { terminalId, ticketId }) {
      const auth = authHeaders(context.state.user.username, context.state.user.token)
      const params = {
        terminal_id: terminalId,
        ticket_id: ticketId
      }
      try {
        const { data } = await axios.post('/public/getTicket', params, { headers: auth })
        const ticket = {}
        ticket.id = ticketId
        ticket.placedAt = data.placedAt
        ticket.status = data.details[0].status
        ticket.betType = data.details[0].betType
        ticket.raceName = data.details[0].raceName
        ticket.raceNumber = data.details[0].raceNumber
        ticket.runnerName = data.details[0].runnerName
        ticket.stake = data.details[0].stake
        ticket.odds = data.details[0].odds
        ticket.betId = data.details[0].id
        ticket.paid = data.paid
        ticket.payoutOwing = data.payoutOwing
        context.commit('setTicket', { ticket: ticket })
      } catch (error) {
        context.commit('setError', error.toString())
      }
    },
    selectTerminal (context, { terminal }) {
      context.commit('setTerminalSelected', { terminal: terminal })
    }
  }
}
